import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { select_release_action } from '../redux/action';
import { usePartial } from 'shared/hooks/utils';
import { Box, Chip, FormControlLabel, ListItemButton, ListItemText, Radio, Typography, } from '@mui/material';
export const Firmware = memo(function Firmware(props) {
    const { release, firmware_version } = props;
    const { select_release } = useAppSelector((state) => state.upgrade_soft);
    const handleReleaseSelect = usePartial(useAction(select_release_action), release);
    return (_jsxs(ListItemButton, { onClick: handleReleaseSelect, sx: {
            alignItems: 'flex-start',
            flexDirection: 'column',
            opacity: firmware_version && firmware_version == release.firmware_version
                ? 0.5
                : 1,
        }, children: [_jsxs(Box, { display: "flex", alignItems: "center", children: [_jsx(FormControlLabel, { control: _jsx(Radio, { value: release.id, checked: release.id === select_release?.release.id }), label: `ВЕРСИЯ ${release.version.endsWith(':1')
                            ? release.version.substring(0, release.version.length - 2)
                            : release.version}` }), release.beta && (_jsx(Chip, { color: "error", variant: "outlined", label: "\u0411\u0435\u0442\u0430", size: "small" }))] }), _jsx(ListItemText, { primary: release.changelog
                    .split('\n')
                    .map((line) => line.replace(/^- /, '– '))
                    .map((line, i) => (_jsx(Typography, { children: line }, i))) })] }));
});
